import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";

const AUTOMATION_PARAM_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusAutomationParam/";

export const automationParamList = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(AUTOMATION_PARAM_ROUTE + "list", {
    params,
    paramsSerializer: { indexes: null },
  });
};
